// extracted by mini-css-extract-plugin
module.exports = {"page":"privacy_page__fXe3L","title":"privacy_title__3hVoa","text":"privacy_text__3XHJq"};